import { createFileRoute } from '@tanstack/react-router'

import { announcementsSearchSchema } from '@/pages/announcements/announcements-search'

export const Route = createFileRoute('/_layout/announcements/')({
  validateSearch: announcementsSearchSchema,
})
